/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from "react";

export interface IRouterContext {
    router: any;
    previousRoute: string | null;
    isPreviousPathExists: boolean;
}

const initialValue: IRouterContext = {
    router: {},
    previousRoute: "",
    isPreviousPathExists: false,
};

const RouterContext = createContext<IRouterContext>(initialValue);

export default RouterContext;
